import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useToast
} from '@chakra-ui/react'
import { useState } from 'react'

import { FormLeadService } from '../../../services/FormLead/FormLeadService'
import { VideoQuizService } from '../../../services/VideoQuiz/VideoQuiz.service'

export interface IProps {
  isOpen: boolean
  onClose: () => void
  id?: number
  onDelete: () => void
  leastDestructiveRef: any
}

export function VideoQuizDeleteDialog({ isOpen, onClose, id, onDelete, leastDestructiveRef }: IProps) {
  const service = new VideoQuizService()
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  const handleDelete = async () => {
    if (!id) return

    setIsLoading(true)
    try {
      await service.delete(id)

      toast({
        title: 'Video Quiz deletado',
        description: 'Video Quiz deletado com sucesso.',
        status: 'success',
        duration: 5000,
        isClosable: true
      })

      onDelete()
      onClose()
    } catch (error) {
      toast({
        title: 'Erro ao deletar o video quiz',
        description: 'Erro ao deletar o video quiz, tente novamente mais tarde.',
        status: 'error',
        duration: 5000,
        isClosable: true
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AlertDialog leastDestructiveRef={leastDestructiveRef} isOpen={isOpen} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Deletar video quiz
          </AlertDialogHeader>

          <AlertDialogBody>Tem certeza que deseja deletar o video quiz?</AlertDialogBody>

          <AlertDialogFooter>
            <Button onClick={onClose} variant="outline">
              Cancelar
            </Button>
            <Button colorScheme="red" onClick={handleDelete} ml={3} isLoading={isLoading}>
              Deletar
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
